

const ENV = process.env.NODE_ENV
console.log('当前环境:', ENV)

// =========================
// ✅ 统一声明变量
// =========================
let apiUrl = ''
let webUrl = ''
let domain = ''
let wsProtocol = ''

// =========================
// ✅ 环境判断
// =========================
if (ENV === 'development') {

    const apiUrlWithoutPort = 'http://localhost'

    apiUrl = `${apiUrlWithoutPort}:8000`
    webUrl = `${apiUrlWithoutPort}:8080`

    domain = '127.0.0.1'
    wsProtocol = 'ws'

} else if (ENV === 'production') {

    apiUrl = ''
    webUrl = ''

    domain = window.location.hostname
    wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws'

}

// =========================
// ✅ 导出（只暴露需要的）
// =========================
export default {
    apiUrl,
    webUrl,
    domain,
    wsProtocol
}









// 旧版本: 待删 (留档记录用)
// if (ENV === 'development') {
//     // apiUrl = 'http://localhost:8000'; // 开发环境  // 只要是用 npm run serve 开启的服务就是开发环境
//     // apiUrl = 'http://192.168.124.12:8000'; // 如果要用手机访问后端数据: 必须要使用具体的本地ip地址! (根据ifconfig可得到!) (否则的话, 用localhost即可)
//     // apiUrl = 'http://192.168.3.23:8000'; // 如果要用手机访问后端数据: 必须要使用具体的本地ip地址! (根据ifconfig可得到!)
//
//     // apiUrlWithoutPort = 'http://192.168.3.114' // 石佛寺ip
//     // apiUrlWithoutPort = 'http://192.168.28.9' // 丽水ip
//     // apiUrlWithoutPort = 'http://192.168.31.149' // 丽水ip
//     apiUrlWithoutPort = 'http://localhost' // 本地ip
//
//     apiUrl = apiUrlWithoutPort + ':8000'  // 后端url
//     webUrl = apiUrlWithoutPort + ':8080' // 前端url
//
//     domain = '127.0.0.1' // 给wss的url用的
//
//
// } else if (ENV === 'production') {
//     // 生产环境不需要加端口的原因: 在nginx代理配置文件中已经指定了/api是访问8000端口
//     // apiUrl = 'https://nuanyu.site'; // 生产环境  // 只要是 npm run build 编译后执行的就是生产环境!!
//     // webUrl = 'https://nuanyu.site'; // 前端url
//
//
//
//     // 260310更新: 不要去硬编码域名!! 否则所有访问这个vue项目的host, 都会被硬编码成主域名; (就永远获取不到子域名了!)
//     apiUrl = ''; // 生产环境  // 只要是 npm run build 编译后执行的就是生产环境!!
//     webUrl = ''; // 前端url
//
//     domain = 'nuanyu.site' // 给wss的url用的
//
//
// }
//
